import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

export default function Presences() {
  const [session, setSession] = useState(null);
  const [list, setList] = useState([]);
  const navigate = useNavigate();

  function getToken() {
    const token = localStorage.getItem("membreToken");
    if (!token) {
      navigate("/login");
      return null;
    }
    return token;
  }

  async function fetchActive() {
    const token = getToken();
    if (!token) return;

    const res = await fetch("/api/presence?action=active", {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (res.status === 403) {
      localStorage.removeItem("membreToken");
      navigate("/login");
      return;
    }

    const json = await res.json();
    setSession(json.session || null);
  }

  async function loadList() {
    if (!session) {
      setList([]);
      return;
    }

    const token = getToken();
    if (!token) return;

    const res = await fetch(
      `/api/presence?action=bySession&session_id=${session.id}`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    if (res.status === 403) {
      localStorage.removeItem("membreToken");
      navigate("/login");
      return;
    }

    const json = await res.json();
    setList(json.data || []);
  }

  useEffect(() => {
    fetchActive();
    const t = setInterval(fetchActive, 5000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    loadList();
    const t = setInterval(loadList, 3000);
    return () => clearInterval(t);
  }, [session]);

  async function start() {
    const token = getToken();
    if (!token) return;

    const res = await fetch("/api/presence?action=start", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (res.status === 403) {
      localStorage.removeItem("membreToken");
      navigate("/login");
      return;
    }

    const j = await res.json();
    if (j.success) setSession(j.session);
    else alert(j.message);
  }

  async function end() {
    const token = getToken();
    if (!token) return;

    const res = await fetch("/api/presence?action=end", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (res.status === 403) {
      localStorage.removeItem("membreToken");
      navigate("/login");
      return;
    }

    const j = await res.json();
    alert(j.message);
    if (j.success) setSession(null);
  }

  function exportExcel() {
    const sheet = XLSX.utils.json_to_sheet(list);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, "Presences");
    XLSX.writeFile(book, `presences_${session?.date || "all"}.xlsx`);
  }

  return (
    <div className="p-4 md:p-6 max-w-5xl mx-auto">
      <h1 className="text-xl md:text-2xl font-bold mb-4">
        📋 Présences – Admin
      </h1>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        {!session ? (
          <button
            onClick={start}
            className="bg-green-600 text-white px-4 py-3 rounded-lg font-semibold"
          >
            ▶ Démarrer session
          </button>
        ) : (
          <button
            onClick={end}
            className="bg-red-600 text-white px-4 py-3 rounded-lg font-semibold"
          >
            ⏹ Clôturer session
          </button>
        )}

        <button
          onClick={exportExcel}
          className="sm:ml-auto bg-blue-600 text-white px-4 py-3 rounded-lg font-semibold"
        >
          ⬇ Export Excel
        </button>
      </div>

      <div className="block md:hidden space-y-4">
        {list.length === 0 && (
          <p className="text-center text-gray-500">
            Aucun membre scanné
          </p>
        )}

        {list.map((p, i) => (
          <div
            key={i}
            className="bg-white rounded-xl shadow p-4 flex justify-between items-center"
          >
            <div>
              <p className="font-bold text-blue-700">
                {p.prenom} {p.nom}
              </p>
              <p className="text-sm text-gray-500">
                ID : {p.member_id}
              </p>

              <p
                className={`mt-1 text-sm font-semibold ${
                  p.status === "present"
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {p.status === "present" ? "Présent" : "Absent"}
              </p>
            </div>

            <div className="text-sm font-mono text-gray-700">
              {p.scanned_at ? p.scanned_at.slice(11, 19) : "—"}
            </div>
          </div>
        ))}
      </div>

      <div className="hidden md:block">
        <table className="w-full bg-white shadow rounded-lg overflow-hidden">
          <thead className="bg-gray-200">
            <tr>
              <th className="p-3 text-left">ID</th>
              <th className="p-3 text-left">Nom</th>
              <th className="p-3 text-left">Statut</th>
              <th className="p-3 text-left">Heure</th>
            </tr>
          </thead>
          <tbody>
            {list.map((p, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="p-3">{p.member_id}</td>
                <td className="p-3">
                  {p.prenom} {p.nom}
                </td>
                <td
                  className={`p-3 font-semibold ${
                    p.status === "present"
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                >
                  {p.status}
                </td>
                <td className="p-3">
                  {p.scanned_at?.slice(11, 19) || "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
